<script>
import StoreRequest from 'App/users/services/StoreRequest';
import DataTableTelefoneColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableTelefoneColumn.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import UserClientStoreStatusColumnVue from 'App/users/components/columns/UserClientStoreStatusColumn.vue';
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import DataTableBooleanColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableBooleanColumn.vue';
import eventBus from '@/plugins/eventBus';
import UserStoreActionColumnVue from '../columns/UserStoreActionColumn.vue';
import UserStoreAntecipacaoAutoColumnVue from '../columns/UserStoreAntecipacaoAutoColumn.vue';
import UserStoreAntecipacaoStatusColumnVue from '../columns/UserStoreAntecipacaoStatusColumn.vue';

export default {
  name: 'UserStoreList',
  extends: CrudListVue,
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    requestClass: StoreRequest,
    editRoute: 'store',
    hideEdit: true,
    hideDelete: true,
    anteciparLoading: false,
    headers: [
      {
        text: 'ID SGV',
        value: 'idClienteSgv',
      },
      {
        text: 'ID ADQ',
        value: 'idEstabelecimentoAdq',
      },
      {
        text: 'Loja',
        value: 'nomLoja',
      },
      {
        text: 'Situação',
        value: 'indStatus',
        component: UserClientStoreStatusColumnVue,
      },
      {
        text: 'Telefone',
        value: 'numTelefone',
        component: DataTableTelefoneColumnVue,
      },
      {
        text: 'Encerramento Habilitado?',
        value: 'indHabilitadoEncerramento',
        component: DataTableBooleanColumnVue,
      },
      {
        text: 'Antecipação automática',
        value: 'antecipacaoAutomaticaAtiva',
        component: UserStoreAntecipacaoAutoColumnVue,
      },
      {
        text: 'Bloqueio de antecipação',
        value: 'isBlockedStatus',
        component: UserStoreAntecipacaoStatusColumnVue,
      },
      {
        text: 'Atualização',
        value: 'updatedDate',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Ações',
        value: 'id',
        component: UserStoreActionColumnVue,
      },
    ],
  }),
  computed: {
    clientId() {
      return this.value;
    },
    setSgvId() {
      return this.handleSgvId;
    },
    handleSgvLoading() {
      return this.handleSyncStoreNameLoading;
    },
    getSwrKey() {
      return `user-store-list-${this.clientId}`;
    },
  },
  watch: {
    rows: {
      immediate: true,
      handler(value) {
        if (!Array.isArray(value)) {
          return;
        }
        const storeSgv = this.rows.find(
          (row) => row && Number(row.idClienteSgv) >= 1,
        );
        if (!storeSgv) {
          return;
        }
        this.setSgvId(storeSgv.idClienteSgv);
      },
    },
  },
  created() {
    eventBus.$on('store-closing-callback', (success) => {
      if (success) this.getData();
    });
  },
  methods: {
    async podeAntecipar() {
      try {
        this.anteciparLoading = true;
        const stores = this.rows;

        await Promise.all(
          stores
            .reduce(
              (reqs, store, index) => {
                if (store.idEstabelecimentoAdq) {
                  reqs.push(
                    this.requestClass.getInfoAntecipacao(store.id)
                      .then(({ data }) => {
                        stores.splice(
                          index,
                          1,
                          Object.assign(store, data),
                        );
                      }),
                  );
                }

                return reqs;
              },
              [],
            ),
        );

        this.rows = stores;
      } catch (err) {
        this.showErrorToast({
          text: this.getMessageError(err),
        });
      } finally {
        this.anteciparLoading = false;
      }
    },
    makeRequest() {
      this.handleSgvLoading();
      this.makeRestRequest();
    },
    finalListRequest() {
      this.prepareLoadings();
      this.handleSgvLoading();
    },
    prepareRequest(params = {}) {
      return this.requestClass.list({
        ClientId: this.clientId,
        ...params,
      }).then(
        (res) => {
          this.podeAntecipar();
          return res;
        },
      );
    },
  },
  reactiveProvide: {
    name: 'userStore',
    include: ['anteciparLoading'],
  },
  inject: {
    handleSyncStoreNameLoading: {
      default() {
        return () => {};
      },
    },
    handleSgvId: {
      default() {
        return () => {};
      },
    },
  },
};
</script>
